<script lang="ts">
	import { getModalContext } from '@astlai/common/contexts/modal.context.svelte.ts';
	import type { Component } from 'svelte';

	export interface MenuItem {
		label: () => string;
		action?: () => void;
		icon?: Component;
	}
	interface Props {
		items: MenuItem[];
	}
	let { items }: Props = $props();

	const modalCtx = getModalContext();
</script>

{#snippet content(item: MenuItem)}
	{#if item.icon}
		<div class="icon">
			<item.icon />
		</div>
	{/if}
	<span>
		{item.label()}
	</span>
{/snippet}

<div class="menu">
	{#each items as item (item.label)}
		{#if item.action}
			<button
				onclick={(e) => {
					modalCtx.closeModal();
					item.action();
					e.stopPropagation();
				}}
				class="menu-item"
			>
				{@render content(item)}
			</button>
		{:else}
			<div class="caption">
				{@render content(item)}
			</div>
		{/if}
	{/each}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.menu {
		@include lib.flex-column();
		gap: 0.25rem;
		padding: 0.25rem;
		width: 100%;

		.menu-item,
		.caption {
			height: auto;
			@include lib.flex-row();
			@include lib.flex-align();
			gap: 0.5rem;
			padding: 0.5rem;
			background: none;
			border-radius: 0.5rem;
			.icon {
				@include lib.flex-row();
				@include lib.flex-align();
				flex: 0 0 auto;
			}
			span {
				@include lib.ellipsis();
			}
		}

		.caption {
			color: var(--text-tertiary);
		}

		.menu-item {
			&:hover {
				background: var(--state-hover);
			}
		}
	}
</style>
